import React from 'react';
import { Seo } from '../components/Seo';
import { SiteHeader } from '../components/SiteHeader';
import { ArticleHero } from '../components/ArticleHero';
import { TableOfContents } from '../components/TableOfContents';
import { WhatIsSection } from '../components/article/WhatIsSection';
import { CompanyProfiles } from '../components/article/CompanyProfiles';
import { ComparisonTable } from '../components/article/ComparisonTable';
import { UseCasesSection } from '../components/article/UseCasesSection';
import { AiAgentsSection } from '../components/article/AiAgentsSection';
import { CustomerSupportSection } from '../components/article/CustomerSupportSection';
import { GovernanceSection } from '../components/article/GovernanceSection';
import { CustomAiSection } from '../components/article/CustomAiSection';
import { EuropeSection } from '../components/article/EuropeSection';
import { SelectionCriteriaSection } from '../components/article/SelectionCriteriaSection';
import { RoiSection } from '../components/article/RoiSection';
import { ImplementationSection } from '../components/article/ImplementationSection';
import { FaqSection } from '../components/article/FaqSection';
import { AuthorCard } from '../components/AuthorCard';
import { FinalCta } from '../components/FinalCta';
import { SiteFooter } from '../components/SiteFooter';
export function ArticlePage() {
  return <div className="min-h-screen w-full bg-night text-ink" data-id="element-254" data-mp="1u5xxp96jjqt4">
      <Seo data-id="element-255" data-mp="1u4d53p3sehxw" />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-aurora-cyan focus:px-4 focus:py-2 focus:font-semibold focus:text-night" data-id="element-256" data-mp="1u43fw3qkget9">
        Skip to content
      </a>
      <SiteHeader data-id="element-257" data-mp="1y6hx6jel76if" />

      <main id="main" data-id="element-258" data-mp="1y5ydax5dm81r">
        <article data-id="element-259" data-mp="1ai8dpo4uiuug">
          <ArticleHero data-id="element-260" data-mp="1ahow68j3y8gy" />
          <div className="mx-auto grid max-w-7xl gap-12 px-5 py-12 md:px-8 md:py-16 lg:grid-cols-[230px_minmax(0,1fr)] xl:gap-20" data-id="element-261" data-mp="1ah5lncvsemcy">
            <div data-id="element-262" data-mp="16f2ayqgxzlsq">
              <TableOfContents data-id="element-263" data-mp="35lwnhccj4doy" />
            </div>
            <div className="min-w-0 max-w-article space-y-12" data-id="element-264" data-mp="35l3owynq4uhw">
              <WhatIsSection data-id="element-265" data-mp="3ak7uzgfcqc40" />
              <CompanyProfiles data-id="element-266" data-mp="3ajewt3ugkuxh" />
              <ComparisonTable data-id="element-267" data-mp="3aidau4bwmo0z" />
              <UseCasesSection data-id="element-268" data-mp="3fawr591z7x9h" />
              <AiAgentsSection data-id="element-269" data-mp="3fbyd48kj645z" />
              <CustomerSupportSection data-id="element-270" data-mp="3fdsnwu238fwc" />
              <GovernanceSection data-id="element-271" data-mp="3kastz4yxting" />
              <CustomAiSection data-id="element-272" data-mp="3k9rgktug8k2k" />
              <EuropeSection data-id="element-273" data-mp="2mmsj4gvxn83m" />
              <SelectionCriteriaSection data-id="element-274" data-mp="2mnkaffihyjo3" />
              <RoiSection data-id="element-275" data-mp="2movhbo78o7jf" />
              <ImplementationSection data-id="element-276" data-mp="2rllvu73eav2q" />
              <FaqSection data-id="element-277" data-mp="2rmn7ods8jlli" />
              <AuthorCard data-id="element-278" data-mp="2rm3yblgni5j3" />
              <FinalCta data-id="element-279" data-mp="2wkykmxdtuc7y" />
            </div>
          </div>
        </article>
      </main>

      <SiteFooter data-id="element-280" data-mp="2wnb81q2ctese" />
    </div>;
}